/*在线学习*/
const Index = () => import(/* webpackChunkName: "group-study" */ '../view/study/Study.vue');
const Course = () => import(/* webpackChunkName: "group-study" */ '../view/study/StudyCourse.vue');
const Detail = () => import(/* webpackChunkName: "group-study" */ '../view/study/StudyDetail.vue');

 const TeacherDetail = () => import(/* webpackChunkName: "group-study" */ '../view/study/teacherDetail.vue');
const studyCourseHome = () => import(/* webpackChunkName: "group-study" */ '../view/study/components/SwitchMain.vue');
const StudyCourseHistory = () => import(/* webpackChunkName: "group-study" */ '../view/study/StudyHistory.vue');
export default [
    {
        path: '/study',
        name: 'study',
        component: Index,
        meta: {
            title: '【旋涡营销】全网网络营销在线学习平台',
            keywords: '网络营销在线学习、网络营销课程，网络营销在线培训，免费网络营销学习',
            description: '旋涡营销在线学习是一家专业的全网营销系统在线学习平台,汇聚了单仁资讯、牛商网多位专家，教您最新的互联网思维,给您最全面的互联网干货内容,网络营销在线学习，变得简单'
        },
        children: [
            {
                path: 'course',
                name: 'study-course',
                component: Course,
                meta: {
                    title: '【旋涡营销】全网网络营销在线学习平台',
                    keepAlive:true
                },
                children:[

                    {
                        path: '/',
                        name: 'studyCourseHome',
                        component: studyCourseHome,
                        meta: {
                            title: '【旋涡营销】全网网络营销在线学习平台',
                            keepAlive:false
                        }
                    },
                    {
                        path: 'studyCourseHistory',
                        name: 'StudyCourseHistory',
                        component: StudyCourseHistory,
                        meta: {
                            title: '【旋涡营销】全网网络营销在线学习平台',
                            keepAlive:false
                        }
                    },

                    {
                        path: 'teacherDetail',
                        name: 'TeacherDetail',
                        component: TeacherDetail,
                        meta: {
                            title: '【旋涡营销】全网网络营销在线学习平台',
                            keepAlive:false
                        }
                    }

                ]
            },
            {
                path: 'detail/:id',
                name: 'study-detail',
                component: Detail,
                meta: {
                    title: '【旋涡营销】全网网络营销在线学习平台'
                }
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./app/router/router-study.js